var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{class:_vm.iconType,attrs:{"icon":['fal', 'bell-on'],"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }